export default "__VITE_ASSET__f9bcffd3__"